const gridOption = {
  gridTheme: function() {
    return {
      name: 'default',
      value: {
        selection: {
          background: '#4daaf9',
          border: '#004082'
        },
        scrollbar: {
          background: '#f5f5f5',
          thumb: '#d9d9d9',
          active: '#c1c1c1'
        },
        row: {
          even: {
            background: '#f4f4f4'
          },
          hover: {
            background: '#ccc'
          }
        },
        cell: {
          normal: {
            background: '#fbfbfb',
            border: '#e0e0e0',
            showVerticalBorder: true
          },
          header: {
            background: '#eee',
            border: '#ccc',
            showVerticalBorder: true
          },
          rowHeader: {
            border: '#ccc',
            showVerticalBorder: true
          },
          editable: {
            background: '#fbfbfb'
          },
          selectedHeader: {
            background: '#d8d8d8'
          },
          focused: {
            border: '#418ed4'
          },
          disabled: {
            text: '#b0b0b0'
          }
        }
      }
    }
  },

  locationBoardGridOption: function() {
    return {
      options: {
        header: {
          height: 30
        },
        bodyHeight: 250,
        selectionUnit: 'row',
        scrollX: true,
        scrollY: true,
        minBodyWidth: 700,
        minBodyHeight: 250,
      },
      showDummyRows: true,
      data:[],
      selectionUnit: 'cell',
      columns: [
        { header: '시설구분', name: 'type', align: 'center', width: 90 },
        { header: '시설명', name: 'name', align: 'left', width: 120 },
        { header: '시설주소', name: 'addr', align: 'left', width: 350 },
        { header: '전화번호', name: 'tel', align: 'center', width: 120 },
        { header: '홈페이지', name: 'url', align: 'left', width: 200 }
      ],
      gridTheme: this.gridTheme()
    }
  },

}


export default gridOption
